import React from "react";
import { Box, Button, Grid, Image, List as DSList, Typography } from "@iho-design-system/Loader";
import EmptySVG from "../../assets/images/icons/empty.svg";
import heartSolidRedSVG from "../../assets/images/icons/heart-solid-red.svg";
import LoadingCustomSVG from "../../assets/images/icons/loading-custom.svg";
import noImage from "../../assets/images/no-image.jpg";
import post from "../../api/post";

const List = ({ props, alertProps, reloadFavoriteProps }) => {
  const [favoritesData, setFavoritesData] = React.useState("loading");
  const [hotelNameSearchKey, setHotelNameSearchKey] = React.useState("");

  React.useEffect(() => {
    if (props.favorites !== "") {
      setFavoritesData(
        props.favorites.status === 200 && props.favorites.data.length > 0
          ? props.favorites.data
          : "empty"
      );
    }
    setHotelNameSearchKey(props.hotelNameSearchKey || "");
  }, [props]);

  const removeFavorite = async (hotelId) => {
    const parameters = {
      ctrl: "UserProfile",
      method: "ChangeFavorite",
      query: "",
      body: { HotelId: hotelId },
    };
    const result = await post(parameters);
    if (result.status === 200) {
      alertProps(["success", "با موفقیت انجام شد"]);
      reloadFavoriteProps(Math.floor(Math.random() * 100));
    } else {
      alertProps(["danger", result.data.Message]);
    }
  };

  const roomReservation = (path) =>
    window.open(`https://iranhotelonline.com${path}#roomReservation`, "_blank");

  const getScale = () => {
    const width = window.innerWidth;
    if (width > 1400) return "xx-large";
    if (width > 1200) return "x-large";
    if (width > 992) return "large";
    if (width > 768) return "medium";
    if (width > 576) return "small";
    return "x-small";
  };
  const scale = getScale();

  if (favoritesData === "loading") {
    return <Image className="d-block mx-auto" src={LoadingCustomSVG} ms={{ width: "40px", height: "40px" }} />;
  }

  if (favoritesData === "empty") {
    return (
      <Box>
        <Image className="mx-auto" src={EmptySVG} ms={{ display: "block", width: "120px", height: "120px" }} />
        <Typography className="d-block text-center" component="h2">
          لیست علاقه‌ مندی‌‌ های شما خالی است :(
        </Typography>
        <Box className="my-md" />
        <Typography className="d-block text-center" component="strong">
          تاکنون هیچ هتلی را ثبت نکرده اید!
        </Typography>
      </Box>
    );
  }

  return (
    <Grid>
      <Grid.Wrapper>
        {favoritesData.map((obj, index) => {
          if (hotelNameSearchKey && !obj.Name.includes(hotelNameSearchKey)) return null;

          const imageUrl = obj.PictureUrl || noImage;
          const listItemContent = (
            <DSList className="bg-white border-solid border-light rounded-lg shadow-dark-hover overflow-hidden d-flex">
              <DSList.Item>
                <Box ms={{ width: scale === "xx-large" || scale === "x-large" || scale === "large" ? "275px" : "100%", minHeight: scale === "xx-large" || scale === "x-large" || scale === "large" ? "200px" : "auto" }}>
                  <img
                    src={imageUrl}
                    alt={obj.Name}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = noImage;
                    }}
                    style={{ width: "100%", height: "auto", objectFit: "cover", display: "block" }}
                  />
                </Box>
              </DSList.Item>
              <DSList.Item className="w-50 p-xl position-relative">
                <Box onClick={() => removeFavorite(obj.HotelId)} className="pointer position-absolute left-xl">
                  <Image src={heartSolidRedSVG} ms={{ width: "24px", height: "24px" }} />
                </Box>
                <Typography className="d-block" ms={{ width: "90%", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }} component="h5">
                  {obj.Name}
                </Typography>
                {obj.Address && (
                  <Typography ms={{ width: "90%", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }} className="my-sm mb-0">
                    {obj.Address}
                  </Typography>
                )}
                <Box className="d-flex align-center justify-content-between w-100 px-xl position-absolute bottom-xl right-0">
                  <Box>
                    <Typography component="small">شروع قیمت از</Typography>
                    <Box className="mx-sm mr-0 divider-horizontal" />
                    <Typography component="strong">{(Math.floor(obj.Price) / 10).toLocaleString()} تومان</Typography>
                  </Box>
                  <Button onClick={() => roomReservation(obj.HotelUrl)} variant="filled" color="primary" size="sm">
                    رزرو کنید
                  </Button>
                </Box>
              </DSList.Item>
            </DSList>
          );

          const colSize = scale === "x-small" ? "col-12" : "col-6";
          return (
            <Grid.Item size={colSize} key={index}>
              {listItemContent}
            </Grid.Item>
          );
        })}
      </Grid.Wrapper>
    </Grid>
  );
};

export default List;
